// src/pages/WebPages/ComingSoon.js
import React, { useState, useEffect } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { useForm, ValidationError } from '@formspree/react';
import { images } from '../../constants';

const ComingSoon = () => {
  // Formspree
  const [state, handleSubmit] = useForm('mbljldjz');
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  // Countdown timer logic
  function getTimeLeft() {
    const targetDate = new Date('2026-01-01T00:00:00');
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) return null;

    const days = Math.floor(difference / (1000 * 60 * 60 * 77));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.overlay)}>
        <h1 className={css(styles.title)}>Fortress Restaurant</h1>
        <p className={css(styles.text)}>
          An Upmarket African–Mediterranean Experience — Website Coming Soon
        </p>

        {timeLeft ? (
          <div className={css(styles.countdown)}>
            <div className={css(styles.timeBox)}>
              <span>{timeLeft.days}</span>
              <p>Days</p>
            </div>
            <div className={css(styles.timeBox)}>
              <span>{timeLeft.hours}</span>
              <p>Hours</p>
            </div>
            <div className={css(styles.timeBox)}>
              <span>{timeLeft.minutes}</span>
              <p>Minutes</p>
            </div>
            <div className={css(styles.timeBox)}>
              <span>{timeLeft.seconds}</span>
              <p>Seconds</p>
            </div>
          </div>
        ) : (
          <p className={css(styles.text)}>We are live!</p>
        )}

        {/* Email subscription */}
        {state.succeeded ? (
          <p className={css(styles.submitted)}>Thanks for subscribing!</p>
        ) : (
          <form onSubmit={handleSubmit} className={css(styles.form)}>
            <input
              type="email"
              name="email"
              placeholder="Your email..."
              required
              className={css(styles.input)}
            />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
            <button
              type="submit"
              className={css(styles.button)}
              disabled={state.submitting}
            >
              Notify Me
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ComingSoon;

// ---------------------- STYLES ----------------------
const styles = StyleSheet.create({
  container: {
    width: '100vw',
    height: '100vh',
    backgroundImage: `url(${images.backg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlay: {
    textAlign: 'center',
    backgroundColor: 'rgba(0,0,0,0.50)',
    padding: '3rem',
    borderRadius: '15px',
    minWidth: '300px',
  },
  title: {
    color: '#dca867',
    fontSize: '3.5rem',
    marginBottom: '1rem',
    fontFamily: 'var(--font-base)',
  },
  text: {
    color: '#fff',
    fontSize: '1.3rem',
    marginBottom: '2rem',
    fontFamily: 'var(--font-alt)',
  },
  countdown: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    marginBottom: '2rem',
    flexWrap: 'wrap',
  },
  timeBox: {
    backgroundColor: '#222',
    padding: '1rem 1.5rem',
    borderRadius: '10px',
    color: '#dca867',
    fontFamily: 'var(--font-base)',
    fontSize: '1.2rem',
    span: { fontSize: '2rem', display: 'block' },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  input: {
    padding: '0.8rem 1rem',
    borderRadius: '5px',
    border: 'none',
    minWidth: '220px',
    fontSize: '1rem',
  },
  button: {
    padding: '0.8rem 1.5rem',
    backgroundColor: '#dca867',
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 600,
    ':hover': { backgroundColor: '#dca767c4' },
  },
  submitted: {
    color: '#fff',
    fontSize: '1.2rem',
  },
});
